// Cihaz API anahtari yonetimi — Raspi'nin sunucuya baglanmasi icin.
// Endpoint: /noktalar/:noktaId/cihaz-anahtarlari
export async function cihazAnahtarlariListele(istemci, noktaId) {
    return istemci.istek(`/noktalar/${noktaId}/cihaz-anahtarlari`);
}
export async function cihazAnahtariOlustur(istemci, noktaId, giris) {
    return istemci.istek(`/noktalar/${noktaId}/cihaz-anahtarlari`, {
        method: 'POST',
        body: JSON.stringify(giris),
    });
}
export async function cihazAnahtariIptal(istemci, noktaId, id, sebep) {
    return istemci.istek(`/noktalar/${noktaId}/cihaz-anahtarlari/${id}`, {
        method: 'DELETE',
        body: JSON.stringify({ sebep }),
    });
}
//# sourceMappingURL=cihaz.js.map